import { SoundButton } from "../../SoundButton/SoundButton";
/*
 * File: SimpleDialogHeader.tsx
 * Description: Reusable simple dialog header component
 **/

import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import "./SimpleDialogHeader.scss";

export interface SimpleDialogHeaderProps {
    title: ReactNode;
    titleId?: string;
    className?: string;
    closeLabel?: string;
    closeIcon?: ReactNode;
    onClose?: () => void;
}

export function SimpleDialogHeader({
    title,
    titleId,
    className,
    closeLabel,
    closeIcon,
    onClose,
}: SimpleDialogHeaderProps) {
    const { t } = useTranslation();

    return (
        <header
            className={["simple-dialog-header", className]
                .filter(Boolean)
                .join(" ")}
        >
            <h2 id={titleId}>{title}</h2>
            {onClose && (
                <SoundButton
                    type="button"
                    className="simple-dialog-header__close"
                    aria-label={closeLabel ?? t("common.closeDialog")}
                    onClick={onClose}
                >
                    {closeIcon ?? "\u00d7"}
                </SoundButton>
            )}
        </header>
    );
}
